import { Injectable } from '@angular/core';

import { apis } from '../../app.constants';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class DataService {

    constructor(private httpService: HttpService,private http: HttpClient) {
    }

     Login = (params: Object) => this.httpService.post(apis.login, params);
     CountersVendedor = (params: Object) => this.httpService.post(apis.get_counters_vendedor, params);
     ActivacionesVendedor = (params: Object) => this.httpService.post(apis.activaciones_vendedor, params);
     InventarioVendedor = (params: Object) => this.httpService.post(apis.inventario_vendedor, params);
     InventarioSubdistribuidores = (params: Object) => this.httpService.post(apis.inventario_subdistribuidores, params);
     ActivacionesSubdistribuidor = (params: Object) => this.httpService.post(apis.activaciones_subdistribuidor, params);
     SimsCaducados = (params: Object) => this.httpService.post(apis.sims_caducados, params);
     SimsPorCaducar = (params: Object) => this.httpService.post(apis.sims_por_caducar, params);
     DetalleReportes = (params: Object) => this.httpService.post(apis.detalle_reportes, params);
     GetSemaforoData = (params: Object) => this.httpService.post(apis.get_semaforo_data, params);
    
    // Perfil methods - Actualizados para usar el backend Terraform
    GetProfile = (params: Object) => this.httpService.post(apis.get_profile, params);
    UpdateProfile = (params: Object) => this.httpService.post(apis.update_profile, params);
    UploadAvatar = (params: Object) => this.httpService.post(apis.upload_avatar, params);
    GetUserStats = (params: Object) => this.httpService.post(apis.get_user_stats, params);
    
    // Admin methods
    GetCsvUploadUrl = (params: Object) => this.httpService.post(apis.get_csv_upload_url, params);
    UploadCsv = (params: Object) => this.httpService.post(apis.upload_csv, params);
    CalcularComisiones = (params: Object) => this.httpService.post(apis.calcular_comisiones, params);
    ListS3Files = (params: Object) => this.httpService.post(apis.list_s3_files, params);
    DownloadPuntosCP = (params: Object) => this.httpService.post(apis.download_puntos_cp, params);
    
    // Usuarios methods
    ListUsers = (params: Object) => this.httpService.post(apis.list_users, params);
    CreateUser = (params: Object) => this.httpService.post(apis.create_user, params);
    UpdateUser = (params: Object) => this.httpService.post(apis.update_user, params);
    // Vendedores methods
    ListVendedores = (params: Object) => this.httpService.post(apis.list_vendedores, params);
    
    // Notificaciones methods
    RegisterDeviceToken = (params: Object) => this.httpService.post(apis.register_device_token, params);
    GetNotifications = (params: Object) => this.httpService.post(apis.get_notifications, params);
    MarkNotificationRead = (params: Object) => this.httpService.post(apis.mark_notification_read, params);
    DeleteNotification = (params: Object) => this.httpService.post(apis.delete_notification, params);
    CreateCampaign = (params: Object) => this.httpService.post(apis.create_campaign, params);
    UpdateCampaign = (params: Object) => this.httpService.post(apis.update_campaign, params);
    ListCampaigns = (params: Object) => this.httpService.post(apis.list_campaigns, params);
    SendNotifications = (params: Object) => this.httpService.post(apis.send_notifications, params);
    
}
